import { render, staticRenderFns } from "./digitalMapOffer.vue?vue&type=template&id=c5c24d06&scoped=true"
import script from "./digitalMapOffer.vue?vue&type=script&lang=js"
export * from "./digitalMapOffer.vue?vue&type=script&lang=js"
import style0 from "./digitalMapOffer.vue?vue&type=style&index=0&id=c5c24d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c24d06",
  null
  
)

export default component.exports